import { useBrand } from '../context/BrandContext';
import FastestFormSitesList from './fastestform/SitesList';
import AbleSitesList from './able/SitesList';

export default function SitesList() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleSitesList /> : <FastestFormSitesList />;
}
